import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import ActionButton from "./ActionButton";
import { assets } from "../data/site";

/**
 * A plain anchor with `download`. The old version created a detached <a>,
 * appended it to the body, clicked it and removed it again, in two places.
 */
const DownloadCvButton = ({ tone = "subtle", size, sx }) => (
  <ActionButton
    tone={tone}
    size={size}
    href={assets.cv.href}
    download={assets.cv.downloadAs}
    startIcon={<DownloadIcon />}
    sx={sx}
  >
    Download CV
  </ActionButton>
);

export default DownloadCvButton;
